import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { fetchRemoveItemFromCart } from "../actions/global";
import { formattedPrice } from "../utils";
import i18next from "i18next";
import { useDispatch } from "react-redux";
import { formatCoffeeType, formatSizeLabel } from "../utils/cellRenderTable";

const CartModalItem = (props) => {
  const { item } = props || {};

  const dispatch = useDispatch();

  const removeItemFromCart = (item) => {
    dispatch(fetchRemoveItemFromCart(item?.id));
  };

  return (
    <div className="cart-content-item">
      <div className="cart-content-item-image">
        <img src={item?.image} alt="Fuka" className="img-fluid" />
        <div className="checkout-information-list-item-qty">
          {item?.quantity}
        </div>
      </div>
      <div className="cart-content-item-text">
        <h5>{item?.name}</h5>
        {item?.productType == "COFFEE" && item?.size && (
          <div className="cart-content-other-info">
            <h6>
              {[
                formatSizeLabel(item?.size),
                item?.frying,
                formatCoffeeType(item?.coffeeType),
              ]
                .filter(Boolean)
                .join(" / ")}
            </h6>
          </div>
        )}
        <div className="cart-content-item-price">
          {item?.discount ? (
            <div className="d-flex justify-content-start gap-2">
              <div className="new-price">
                {formattedPrice(item?.discountPrice)} RSD
              </div>
              <div className="old-price">{formattedPrice(item?.price)} RSD</div>
            </div>
          ) : (
            <div className="new-price">{formattedPrice(item?.price)} RSD</div>
          )}
        </div>
      </div>
      <div
        className="cart-content-item-remove"
        onClick={() => removeItemFromCart(item)}
      >
        <FontAwesomeIcon icon={faClose} />
      </div>
    </div>
  );
};

export default CartModalItem;
